import { useQuery } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import { chatsApi } from "@/lib/humhub-api/chats";

export const useChatRooms = (initialPage = 1, initialPerPage = 20) => {
  const [page, setPage] = useState<number>(initialPage);
  const [perPage, setPerPage] = useState<number>(initialPerPage);

  // React Queryでデータ取得
  const {
    data: chatRooms,
    isLoading: loading,
    error: queryError,
    refetch: queryRefetch,
  } = useQuery({
    queryKey: ["chatRooms", { page, perPage }],
    queryFn: () => chatsApi.getChatRooms(page, perPage),
    staleTime: 1 * 60 * 1000, // チャットルーム一覧は1分間キャッシュ（新着メッセージを考慮し短め）
  });

  const handlePageChange = useCallback((newPage: number) => {
    setPage(newPage);
  }, []);

  const handlePerPageChange = useCallback((newPerPage: number) => {
    setPerPage(newPerPage);
    setPage(1);
  }, []);

  const refetch = useCallback(() => {
    return queryRefetch();
  }, [queryRefetch]);

  return {
    data: chatRooms?.results || [],
    pagination: chatRooms
      ? {
          total: chatRooms.total,
          page,
          perPage,
          pages: chatRooms.pages,
          links: chatRooms.links,
        }
      : undefined,
    isLoading: loading,
    error: queryError ? String(queryError) : null,
    handlePageChange,
    handlePerPageChange,
    refetch,
    // refreshCounterを削除 - React Queryのinvalidationに任せる
  };
};
